import { useQuery } from '@tanstack/react-query';
import { bannerApi } from '../../api/banner';
import { useWebLocale } from '../../contexts/WebLocaleContext';
export function useBanners() {
  const { locale } = useWebLocale();
  return useQuery({
    queryKey: ['home-banners', 'app-inventory', locale],
    queryFn: ({ signal }) => bannerApi.getBanners(locale, signal),
    staleTime: 60000,
    retry: 1,
  });
}
